import { usePostAuthRefreshMutation } from "@ud/api";
import { redirectToLoginPage } from "@ud/api/phpApi/baseQuery";

const useRefresh = (): { getFreshToken: () => { accessToken?: string } } => {
  const [callResponse, {}] = usePostAuthRefreshMutation();
  const accessToken = sessionStorage.getItem("ACCESS_TOKEN");
  const refreshToken = localStorage.getItem("REFRESH_TOKEN");
  const getFreshToken = (): { accessToken?: string } => {
    if (accessToken) {
      return { accessToken };
    }
    if (!accessToken && refreshToken) {
      callResponse({
        body: { refreshToken },
      })
        .unwrap()
        .then((res) => {
          sessionStorage.setItem("ACCESS_TOKEN", res.accessToken);
          localStorage.setItem("REFRESH_TOKEN", res.refreshToken);

          return { accessToken: res.accessToken };
        })
        .catch(() => {
          sessionStorage.removeItem("ACCESS_TOKEN");
          localStorage.removeItem("REFRESH_TOKEN");
          window.location.href = `${
            window.location.origin
          }${redirectToLoginPage()}`;

          return {};
        });
    }
    window.location.href = `${window.location.origin}${redirectToLoginPage()}`;

    return {};
  };

  return { getFreshToken };
};

export default useRefresh;
